<template>
  <div>
    <VehicleInfo v-if="vehicleString" :displayVehiclePrice="false" :wrapperCSSClasses="'container-wrapper'">
    </VehicleInfo>
    <div class="container-wrapper full-height no-top-space pb-0 mb-0" :class="{ 'with-vehicle-desc': vehicleString }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VehicleInfo from '@/components/VehicleInfo.vue';

export default {
  name: 'SpinWrapper',
  components: {
    VehicleInfo,
  },
  computed: {
    ...mapGetters({
      vehicleString: 'vehicle/vehicleString',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
